<p class="mb-2 mt-2 text-gray-30">Here are some ways to get started.</p>
@for (category of this.expandableCategories; track category.id) {
    <div class="card card-hover bg-white mb-row" [class.active]="category.expanded" style="padding: 0;">
        <div class="d-flex card-md" (click)="toggleCategory(category)">
            <div class="card-sidebar pr-2">
                <div class="card-sidebar-icon" [style.backgroundColor]="category.background_color">
                    <svg [class]="category.icon" ycnIcon [name]="category.icon"></svg>
                </div>
            </div>
            <div class="card-body">
                <div class="card-title pb-4px">{{ category.title }}</div>
                <div class="text-small text-gray-50">{{ category.description }}</div>
            </div>
            <div class="card-sidebar pl-2"><div class="card-collapse-toggler collapse-chevron rotate-90"></div></div>
        </div>
        <div class="card-collapse" [class.collapse]="!category.expanded">
            <div class="card-collapse-menu">
                @for (subcategory of category.subcategories; track subcategory.id) {
                    <a class="card-collapse-menu-item" href="javascript:void(0)"
                        (click)="selectSteps(category, subcategory)">{{ subcategory.title }}</a>
                }
            </div>
        </div>
    </div>
}